// extracted by mini-css-extract-plugin
var _1 = "LWPMmY";
var _2 = "KrwcmA";
var _3 = "awDkaV";
var _4 = "rwvIR_";
var _5 = "YDZ5wC";
var _6 = "rdSNqa";
var _7 = "kKUIYO";
var _8 = "Bx241L";
var _9 = "_LAGUc";
var _a = "RRwaTs";
var _b = "Ic2xmh";
var _c = "dAwJko";
var _d = "Bxbd7L";
var _e = "RweOGl";
var _f = "bh5fe2";
var _10 = "ywo9dy";
var _11 = "TWkbOV";
export { _1 as "accent", _2 as "button", _3 as "disabled", _4 as "ease-transition", _5 as "gradient-titanic-80", _6 as "linear-transition-05", _7 as "loading", _8 as "primary", _9 as "secondary", _a as "shadow-medium-titanic", _b as "shadow-medium-titanic-hover", _c as "shadow-titanic-1", _d as "shadow-white", _e as "size-24", _f as "size-40", _10 as "size-48", _11 as "size-56" }
